import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OCP_DOCUMENT_TYPES } from "./apiRoutes";

interface UseGetOCPDocumentListProps {
  communityId: string;
  ocpStage: "CLOSING_PACKAGE" | "OWNER_ONBOARDING" | "OWNERSHIP_CHANGE_DOC";
  activeOnly?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOCPDocumentList = async ({communityId, ocpStage, activeOnly = true}: UseGetOCPDocumentListProps) =>
  await axiosAuth.get(`${OCP_DOCUMENT_TYPES}?communityId=${communityId}&ocpStage=${ocpStage}&activeOnly=${activeOnly}`);

const useGetOCPDocumentList = ({
  communityId,
  ocpStage,
  activeOnly,
  queryParams,
}: UseGetOCPDocumentListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ocp-document-types", communityId],
    queryFn: () => getOCPDocumentList({communityId, ocpStage, activeOnly}),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId,
    ...queryParams,
  });
};

export default useGetOCPDocumentList;
